import { rootStore } from "../Store/rootStore";

export default function setImporting(show: boolean = false) {
    if (show) {
        rootStore.dispatch({ type: "IMPORTING", show: true })
    } else {
        rootStore.dispatch({ type: "NOT_IMPORTING", show: false })
    }
}
